import { render, staticRenderFns } from "./IndicationTemp.vue?vue&type=template&id=2ac70be7&scoped=true"
import script from "./IndicationTemp.vue?vue&type=script&lang=js"
export * from "./IndicationTemp.vue?vue&type=script&lang=js"
import style0 from "./IndicationTemp.vue?vue&type=style&index=0&id=2ac70be7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac70be7",
  null
  
)

export default component.exports